import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthUser } from '../actions/Autentificate/AuthAction';
import AllRoutes from '../nametitle/AllRoutes'

const LoginAdmin = () => {
    const  navigate  =  useNavigate("");
    const [username,  setusername] =  useState()
    const [password,  setpassword] =  useState();
    const [messageError,  setmessageError] =  useState();
    const [isvisible, setisvisible] = useState(false);


    return (
        <section className="vh-100 gradient-custom bg-gradient-to-t from-blue-900 to-transparent">
            <form className="container py-5 h-100" 
            onSubmit={(e)=>{
                e.preventDefault();
                AuthUser(username,password,setmessageError,navigate);
            }}
            >
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                        <div className="card bg-dark text-white" style={{ borderRadius: "1rem" }}>
                            <div className="card-body p-5 text-center">

                                <div className="mb-md-5 mt-md-4 pb-5">

                                    <h2 className="fw-bold mb-2 text-uppercase text-white text-2xl translatable">Se connecter a votre espcace </h2>
                                    <p className="text-white-50 mb-5 translatable">Veillez entrez vos informations de connexion s{"'"} il vous plaît</p>

                                    <div className="w-full  flex-start form-outline form-white mb-1">
                                        <label className="form-label translatable" for="typeEmailX">Nom d{"'"}utilisateur</label>

                                        <input value={username} onChange={(e)=>{setusername(e.target.value)}} type="text" id="typeEmailX" className="form-control form-control-lg" />
                                    </div>
                                    <div className="w-full  flex-start form-outline form-white mb-4">
                                        <label className="form-label translatable" for="typePasswordX">mot de passe</label>
                                        <input value={password} onChange={(e)=>{setpassword(e.target.value)}} type={isvisible ? "text":"password"} id="typePasswordX" className="form-control form-control-lg" />
                                    </div>
                                    <div className="w-full  flex-start form-outline form-white mb-4">
                                        <input type="checkbox" checked={isvisible} onChange={(e)=>{setisvisible(e.target.checked)}}  style={{height:"20px"}} />
                                        <label className="form-label translatable" for="typePasswordX">Afficher mot de passe</label>
                                    </div>
                                    <div className="form-outline form-white mb-4">
                                        <label className="form-label text-danger translatable" for="typePasswordX">{messageError}</label>
                                    </div>

                                    {
                                        /**
                                         * <p className="small mb-5 pb-lg-2"><a className="text-white-50" href="#!">Forgot password?</a></p>
                                         */
                                    }
                                    <button className="w-full btn btn-outline-light btn-lg px-5 translatable" type="submit" 
                                    >Se connecter</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    )
}

export default LoginAdmin